<template>
  <div id="app-root">
    <router-view />
    <ToastContainer />
  </div>
</template>

<script>
import ToastContainer from './components/common/Toast.vue'
export default {
  name: 'App',
  components: { ToastContainer }
}
</script>
